import React from "react";
import {
  FaCogs,
  FaHandshake,
  FaLightbulb,
  FaShieldAlt,
  FaChartLine,
} from "react-icons/fa";
import { motion } from "framer-motion";
import { AppConstant } from "../AppConstant";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import OurTeam from "./OurTeam";
import USAMap from "./USAMap";
import OrgChart from "./OrgChart";
import JourneyTimeline from "../Components/JourneyTimeline";

const About = () => {
  const cards = [
    {
      title: "End-to-End Solutions",
      text: "From Concept Validation and Detailed Design to Shop Drawing Preparation and Site Support.",
      color: "#00c6c2",
    },
    {
      title: "Collaborative Approach",
      text: "Early Engagement Ensures Seamless Integration with Project Stakeholders.",
      color: "#2196f3",
    },
    {
      title: "Cost & Time Efficiency",
      text: "Optimized Workflows and Proactive Problem-Solving Minimize Delays and Budget Overruns.",
      color: "#f44336",
    },
    {
      title: "Commitment to Safety",
      text: "Designs Grounded in Rigorous Analysis and Adherence to the Latest Safety Standards.",
      color: "#f36f21",
    },
  ];

  const values = [
    {
      title: "Technical Excellence:",
      text: "Upholding the Highest Standards of Analysis, Design, and Detailing.",
      icon: FaCogs,
      color: "#00c6c2",
    },
    {
      title: "Client-Centric Service:",
      text: "Building Long-Term Relationships Through Responsiveness, Transparency, and Collaboration.",
      icon: FaHandshake,
      color: "#2196f3",
    },
    {
      title: "Innovation:",
      text: "Embracing Cutting-Edge Tools, Methods, and Sustainable Practices.",
      icon: FaLightbulb,
      color: "#f36f21",
    },
    {
      title: "Integrity:",
      text: "Conducting All Business with Honesty, Accountability, and Respect.",
      icon: FaShieldAlt,
      color: "#ff9800",
    },
    {
      title: "Continuous Improvement:",
      text: "Investing in Growth, Technology & Process Excellence.",
      icon: FaChartLine,
      color: "#f44336",
    },
  ];

  return (
    <>
      <Header />
      <div style={styles.container}>
        {/* Heading */}
        <motion.h2
          style={styles.title}
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Why Choose{" "}
          <span style={styles.highlight}>StructGuard Engineers LLP?</span>
        </motion.h2>
        {/* <h2 style={{ textDecoration: 'underline 2px #F37021',  textUnderlineOffset: '10px', letterSpacing: '5px' }}>hii </h2> */}
        {/* Feature Row */}
        {/* <div style={styles.row}>
        {cards.map((card, index) => (
          <motion.div
            key={index}
            style={styles.cardContainer}
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            whileHover={{ scale: 1.05 }}
          >
            <motion.div
              style={{ ...styles.circle, backgroundColor: card.color }}
              whileHover={{ rotate: 360 }}
              transition={{ duration: 0.6 }}
            />
            <motion.div
              style={styles.line}
              initial={{ height: 0 }}
              whileInView={{ height: 40 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            />
            <div style={styles.cardText}>
              <strong>{card.title}</strong>
              <br />
              {card.text}
            </div>
          </motion.div>
        ))}
      </div> */}

        {/* <div style={styles.cardsGrid}>
        {cards.map((card, i) => (
          <motion.div
            key={i}
            style={{ ...styles.card, background: card.color }}
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: i * 0.2 }}
            whileHover={{ scale: 1.05, rotate: -1 }}
            viewport={{ once: true }}
          >
            <motion.div
              style={{ ...styles.circle, backgroundColor: card.color }}
              whileHover={{ rotate: 360 }}
              transition={{ duration: 0.6 }}
            />
            <motion.div
              style={styles.line}
              initial={{ height: 0 }}
              whileInView={{ height: 40 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            />
            <h3 style={styles.cardTitle}>{card.title}</h3>
            <p style={styles.cardText}>{card.text}</p>
          </motion.div>
        ))}
      </div> */}

        <div style={styles.cardsGrid}>
          {cards.map((card, i) => (
            <motion.div
              key={i}
              style={{ ...styles.card, background: card.color }}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: i * 0.2 }}
              whileHover={{ scale: 1.05, rotate: -1 }}
              viewport={{ once: true }}
            >
              {/* Circle with opposite color */}
              <motion.div
                style={{
                  ...styles.circle,
                  backgroundColor: '#f9fafc',
                }}
                whileHover={{ rotate: 360 }}
                transition={{ duration: 0.6 }}
              />

              <motion.div
                style={styles.line}
                initial={{ height: 0 }}
                whileInView={{ height: 40 }}
                transition={{ duration: 0.6, delay: 0.3 }}
              />

              <h3 style={styles.cardTitle}>{card.title}</h3>
              <p style={styles.cardText}>{card.text}</p>
            </motion.div>
          ))}
        </div>



        {/* Core Values */}
        <motion.h2
          style={{ ...styles.title, marginTop: 80 }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          Core <span style={styles.highlight}>Values</span>
        </motion.h2>

        <div style={styles.valuesContainer}>
          {values.map((item, index) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={index}
                style={{
                  ...styles.valueItem,
                  flexDirection: index % 2 === 0 ? "row" : "row-reverse",
                  //  textAlign: index % 2 === 0 ? "left" : "right",
                }}
                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.7, delay: index * 0.2 }}
              >
                <motion.div
                  style={styles.iconBox(item.color)}
                  whileHover={{ scale: 1.2, rotate: 15 }}
                  transition={{ duration: 0.3 }}
                >
                  <Icon style={styles.iconStyle} />
                </motion.div>
                <div style={styles.textBox}>
                  <strong>{item.title}</strong> {item.text}
                </div>
              </motion.div>
            );
          })}
        </div>

        {/* <div style={styles.valuesContainer}>
          {values.map((item, index) => {
            const Icon = item.icon;
            const isEven = index % 2 === 0;

            return (
              <motion.div
                key={index}
                style={{
                  ...styles.valueItem,
                  flexDirection: "row", // always row
                }}
                initial={{ opacity: 0, x: isEven ? -50 : 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.7, delay: index * 0.2 }}
              >
            
                <motion.div
                  style={{
                    ...styles.iconBox(item.color),
                    order: isEven ? 0 : 2, // left if even, right if odd
                  }}
                  whileHover={{ scale: 1.2, rotate: 15 }}
                  transition={{ duration: 0.3 }}
                >
                  <Icon style={styles.iconStyle} />
                </motion.div>

              
                <div
                  style={{
                    fontWeight: "bold",
                    margin: "0 10px",
                    order: 1, // always center
                  }}
                >
                  {item.title}
                </div>

               
                <div
                  style={{
                    ...styles.textBox,
                    order: isEven ? 2 : 0, // right if even, left if odd
                  }}
                >
                  {item.text}
                </div>
              </motion.div>
            );
          })}
        </div> */}

        <div style={{ overflowX: "auto", width: "100%" }}>
          <USAMap style={{ minWidth: "300px", maxWidth: "100%" }} />
        </div>
        <div style={{ overflowX: "auto", width: "100%" }}>
          <OurTeam style={{ minWidth: "300px", maxWidth: "100%" }} />
        </div>
        <div style={{ overflowX: "auto", width: "100%" }}>
          <OrgChart style={{ minWidth: "300px", maxWidth: "100%" }} />
        </div>
        {/* <div style={{ overflowX: "auto", width: "100%" }}>
          <JourneyTimeline style={{ minWidth: "300px", maxWidth: "100%" }} />
        </div> */}

      </div>
      <Footer />
    </>
  );
};

const styles = {
  container: {
    padding: "60px 30px",
    textAlign: "center",
    backgroundColor: "white",
    // backgroundImage: AppConstant.backgroundtextilerdesign,
    // backgroundAttachment: AppConstant.backgroundAttachmentscroller,

    minHeight: "100vh",

  },
  title: {
    fontSize: "clamp(28px, 6vw, 60px)", // min 28px, fluid, max 60px
    fontWeight: "bold",
    marginBottom: "30px",
    lineHeight: "1.2",
    wordBreak: "break-word", // prevent overflow
  },

  highlight: {
    color: "#f36f21",
  },
  row: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "40px",
  },
  cardContainer: {
    width: "240px",
    padding: "20px",
    borderRadius: "16px",
    background: "rgba(255, 255, 255, 0.6)",
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
    backdropFilter: "blur(6px)",
    textAlign: "center",
  },
  circle: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    margin: "0 auto 10px",
    // background:'red',
  },
  line: {
    width: "2px",
    height: "40px",
    backgroundColor: "#ffff",
    margin: "0 auto 10px",
  },
  cardText: {
    fontSize: "15px",
    lineHeight: "1.6",
    // textTransform: "capitalize",
  },
  valuesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    marginTop: "50px",
    maxWidth: "950px",
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "left",
  },
  valueItem: {
    display: "flex",
    flexDirection: "row", // keep icon + text side by side
    alignItems: "center", // vertical center alignment
    gap: "20px",
    padding: "20px",
    borderRadius: "12px",
    background: "rgba(255, 255, 255, 0.7)",
    boxShadow: "0 6px 15px rgba(0,0,0,0.08)",
    backdropFilter: "blur(6px)",
  },

  // valueItem: {
  //   display: "flex",
  //   alignItems: "center",
  //   gap: "20px",
  //   padding: "20px",
  //   borderRadius: "12px",
  //   background: "rgba(255, 255, 255, 0.7)",
  //   boxShadow: "0 6px 15px rgba(0,0,0,0.08)",
  //   backdropFilter: "blur(6px)",
  // },
  iconBox: (color) => ({
    width: "60px",
    height: "60px",
    backgroundColor: color,
    borderRadius: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),
  iconStyle: {
    fontSize: "28px",
    color: "white",
  },
  textBox: {
    fontSize: "15px",
    lineHeight: "1.6",
    maxWidth: "750px",
    // textTransform: "capitalize",

  },
  // cardsGrid: {
  //   display: "grid",
  //   gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
  //   gap: "30px",
  //   maxWidth: "1100px",
  //   margin: "0 auto",
  // },

  cardsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", // smaller min width
    gap: "20px",
    maxWidth: "100%", // prevent extra width
    margin: "0 auto",
    padding: "0 10px", // add breathing space on mobile
  },

  card: {
    padding: "30px",
    borderRadius: "20px",
    color: "#fff",
    boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
    transition: "all 0.3s ease",
    cursor: "pointer",

  },
  cardTitle: {
    fontSize: "20px",
    marginBottom: "10px",
  },

};


export default About;
// Example inside component or global CSS
<style>
  {`
  @media (max-width: 480px) {
    h2 {
      font-size: 2rem !important;
      margin-bottom: 30px;
    }

    .cardsGrid {
      gap: 15px !important;
    }

    .card {
      padding: 15px !important;
    }

    .valueItem {
      gap: 10px !important;
      padding: 10px !important;
      flexDirection: column !important;
      alignItems: flex-start !important;
    }

    .textBox {
      font-size: 0.85rem !important;
    }
  }
    @media (max-width: 480px) {
  h2 {
    font-size: 1.8rem !important;
    line-height: 1.2;
  }
  .cardsGrid {
    grid-template-columns: 1fr !important;
    padding: 0 10px !important;
  }
  .valueItem {
    flex-direction: column !important;
    align-items: flex-start !important;
  }
}

`}
</style>
